import { HtmlDataProcessor } from 'ckeditor5/src/engine';
import { CKEditorError } from 'ckeditor5/src/utils';

export default class PlanejamentoDataProcessor extends HtmlDataProcessor {
	/**
	 * Creates a new instance of the HTML data processor class.
	 *
	 * @param {ViewDocument} document The view document instance.
	 */
	constructor( document ) {
		super( document );
	}

	toData( viewFragment ) {
		const children = Array.from( viewFragment.getChildren() );
		const hasPlanejamento = children.some( c => c.is( 'element', 'planejamento' ) );
		const hasOtherThanPlanejamento = children.some( c => !c.is( 'element', 'planejamento' ) );

		if ( hasPlanejamento && hasOtherThanPlanejamento ) {
			throw new CKEditorError( 'Editor com texto fora dos dispositivos.' );
		} else if ( hasPlanejamento ) {
			const json = [];
			for ( const child of viewFragment ) {
				const est = JSON.parse( atob( child.getAttribute( 'data' ) ) );
				let txhtml = '';
				for ( const content of child.getChildren() ) {
					txhtml += super.toData( content )
						.replace( /<span class="planejamentoLabel">.*?<\/span>/g, '{{prefixo}}' );
				}
				Object.assign( est, {
					txhtml: txhtml
				} );
				json.push( est );
			}
			return json;
		} else {
			return super.toData( viewFragment );
		}
	}

	toView( json ) {
		let text = '';
		if ( Array.isArray( json ) ) {
			for ( let idx = 0; idx < json.length; idx++ ) {
				const data = Object.assign( {}, json[ idx ] );
				delete data.txhtml;
				delete data.texto;
				const html = json[ idx ].txhtml
					.replace( /{{prefixo}}/g, '<span class="planejamentoLabel"></span>' )
					.replace( /{{([^{}"]+)}}/g, '<span class="funcao" data="$1"></span>' );
				text += `<planejamento data="${ btoa( JSON.stringify( data ) ) }">${ html }</planejamento>`;
			}
		} else {
			text = json;
		}
		return super.toView( text );
	}
}
